/**
 * Betrieb → Baselining (tri-server docs/fm-baselining-entwurf.md). Ein Panel mit Reitern: Auswertung (Pivot),
 * Leistungskatalog und Spaltenzuordnungen der ERP-Exporte. Der Reiter steht in der Adresse (`?tab=`), damit ein Link genau ihn öffnet.
 */

import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import ServiceCatalogueTab from "./ServiceCatalogueTab";
import ColumnMappingsTab from "./ColumnMappingsTab";
import AnalysisTab from "./AnalysisTab";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const BASELINING_TABS = ["analysis", "catalogue", "mappings"] as const;
export type BaseliningTab = (typeof BASELINING_TABS)[number];

export const baseliningTabFrom = (value: string | null): BaseliningTab =>
  (BASELINING_TABS as readonly string[]).includes(value ?? "") ? (value as BaseliningTab) : "analysis";

export default function BaseliningPanel() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = baseliningTabFrom(searchParams.get("tab"));

  const select = (value: string) => {
    const next = new URLSearchParams(searchParams);
    next.set("tab", value);
    setSearchParams(next, { replace: true });
  };

  return (
    <Tabs value={tab} onValueChange={select} className="space-y-4">
      <TabsList>
        <TabsTrigger value="analysis">{t("baselining.tabs.analysis")}</TabsTrigger>
        <TabsTrigger value="catalogue">{t("baselining.tabs.catalogue")}</TabsTrigger>
        <TabsTrigger value="mappings">{t("baselining.tabs.mappings")}</TabsTrigger>
      </TabsList>
      <TabsContent value="analysis">
        <AnalysisTab />
      </TabsContent>
      <TabsContent value="catalogue">
        <ServiceCatalogueTab />
      </TabsContent>
      <TabsContent value="mappings">
        <ColumnMappingsTab />
      </TabsContent>
    </Tabs>
  );
}
